import React, { useRef, useEffect, useState } from 'react';

const CertificateGenerator = ({ name, assessment, date, time, onClose }) => {
  const canvasRef = useRef(null);
  const [loading, setLoading] = useState(true);

  // Draw the certificate with dynamic data
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const image = new window.Image();
    image.src = '/Certificate.jpg'; // Use the correct filename as in the public folder

    image.onload = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

      // Name (centered under "This is to certify that")
      ctx.font = ' 60px Arial bold';
      ctx.fillStyle = '#F9A825';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'middle';
      ctx.fillText(name, 636, 315);

      // Assessment (centered on the line)
      ctx.font = '26px Arial bold';
      ctx.fillStyle = '#000';
      ctx.textAlign = 'left';
      ctx.fillText(assessment, 666, 445);

      // Date (on the line after "on")
      ctx.font = ' 22px Arial';
      ctx.textAlign = 'left';
      ctx.fillText(date, 668, 490);

      // // Time (on the line after "at")
      // ctx.font = 'bold 32px Arial';
      // ctx.textAlign = 'left';
      // ctx.fillText(time, 800, 470);

      setLoading(false);
    };

    image.onerror = () => {
      ctx.fillStyle = 'red';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.font = 'bold 40px Arial';
      ctx.fillStyle = '#fff';
      ctx.fillText('Image not found!', 100, 100);
      setLoading(false);
    };
  }, [name, assessment, date, time]);

  // Download handler
  const handleDownload = () => {
    const canvas = canvasRef.current;
    const link = document.createElement('a');
    link.download = 'certificate.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <canvas
        ref={canvasRef}
        width={1365}
        height={768}
        style={{ width: '100%', maxWidth: 800, border: '1px solid #ccc', background: '#fff' }}
      />
      <div style={{ marginTop: 16 }}>
        {loading && <div>Loading certificate...</div>}
        <div className="flex justify-center items-center space-x-3">
          <button 
            onClick={handleDownload} 
            className="px-5 py-2.5 bg-blue-600 text-white rounded-md 
                    font-medium shadow-sm hover:bg-blue-700 transition-all 
                    duration-200 flex items-center justify-center focus:outline-none min-w-[200px]"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            Download Certificate
          </button>
          {onClose && 
            <button 
              onClick={onClose} 
              className="px-5 py-2.5 bg-gray-600 text-white rounded-md 
                      font-medium shadow-sm hover:bg-gray-700 transition-all 
                      duration-200 flex items-center justify-center focus:outline-none min-w-[120px]"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              Close
            </button>
          }
        </div>
      </div>
    </div>
  );
};

export default CertificateGenerator; 